import React from "react";
import { getZscalerURLParams } from "./../utilities/utilities";
import AttentionMessage from "../components/attention-message";
import Details from "../components/details";
import Disclaimer from "../components/disclaimer";
import Header from "../components/header";
import ReasonCode from "./../components/reason-code";
import SafetyNotice from "../safety-notice";
import ServiceNowLink from "../components/servicenow-link";
import SupportDirections from "./../components/support-directions";
import config from "../config";

const BlockOEPage = () => {
  const params = getZscalerURLParams();
  
  return (
    <div className="main fade-up">
      <Header content="Restricted Website Access" />
      <AttentionMessage content={`REASON CODE: ${params.reasoncode}`} />

      <div className="content fade-in">
        <div className="exception-description">
          <p>
          <b>Access to OpenEvidence.com has been suspended while Trinity Health completes a review of usage and security considerations. The Help Desk has been informed, and no additional ticket is required.
          For the latest information and messaging from clinical leadership, please use the link below:</b>
          </p>
          <p>
            <a href="https://mytrinityhealth.sharepoint.com/sites/OpenEvidenceCommunicationPage/SitePages/Home.aspx"
               target="_blank"><b>Open Evidence Communication Page</b></a> 
          
          </p>
        </div>
      </div>
      
      <div className="support-information">
        <h2>Support Information</h2>
        <Details />
      </div>
      <SafetyNotice />
      <Disclaimer />
    </div>
    );
};

export default BlockOEPage;
